<template>
  <div class="payBox">
    <!-- 顶部选择地址等 -->
    <div class="payHead">
      <div class="payHead_list">
        <div class="payHead_listLabel">收货地址：</div>
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="JSON.parse(item.address).label"
            :value="JSON.parse(item.address).label"
          >
          </el-option>
        </el-select>
        <el-link
          type="primary"
          :underline="false"
          style="margin-left: 11px"
          @click="showDialog()"
          >新增收货地址</el-link
        >
      </div>
      <div class="payHead_list">
        <div class="payHead_listLabel">支付方式：</div>
        <div class="payHead_mode payHead_active">线下对公付款</div>
        <!-- <div class="payHead_mode">余额账户</div> -->
      </div>
      <div class="payHead_list">
        <div class="payHead_listLabel">配送方式：</div>
        <div class="payHead_mode payHead_active">厂商直送</div>
      </div>
    </div>
    <!-- 商品信息 -->
    <div class="payMain">
      <!-- 表头 -->
      <div class="payMain_head">
        <div class="payMain_headList" style="width: 471px">商品</div>
        <div class="payMain_headList" style="width: 224px">单位</div>
        <div class="payMain_headList" style="width: 185px">单价</div>
        <div class="payMain_headList" style="width: 111px">数量</div>
        <div class="payMain_headList" style="width: 130px">总计</div>
      </div>
      <!-- 商品列表 -->
      <div
        class="payMain_list"
        v-for="(item, index) in goodsList"
        :key="index"
        v-if="item.info.wholesalePrice"
      >
        <div class="payMain_listGoods">
          <img
            :src="item.info.thumb"
            alt=""
            style="width: 139px; height: 144px"
          />
          <div class="payMain_listGoodsR">
            <span class="payMain_listGoodsText1">{{ item.info.title }}</span
            ><span class="payMain_listGoodsText2">{{ item.info.spec }}</span>
          </div>
        </div>
        <div class="payMain_listUnit">{{ item.info.unit }}</div>
        <div class="payMain_listPrice">
          <span>￥{{ item.info.wholesalePrice.toFixed(2) }}</span>
          <span><!--￥{{ item.info.pcProductPrice.toFixed(2) }}--></span>
        </div>
        <div class="payMain_listNum">x{{ item.info.num }}</div>
        <div class="payMain_listTotal">
          ￥{{ (item.info.wholesalePrice * item.info.num).toFixed(2) }}
        </div>
      </div>
      <!-- 发票信息 -->
      <div class="payMain_foot">
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入备注信息"
          v-model="buyRemark"
          resize="none"
          style="width: 500px"
        >
        </el-input>
        <span class="payMain_footTip">
          请确认您的订购商品及数量，供应商将按照您的订单给您发货</span
        >
        <!-- <el-tooltip
          effect="light"
          :value="true"
          content="开企业抬头发票须填写纳税人识别号，以免影响报销"
          placement="right-end"
        >
          <span class="payMain_footTitle">发票信息</span>
        </el-tooltip>
        <div class="payMain_footMain">
          <el-link :underline="false" class="payMain_footList"
            >普通发票
          </el-link>
          <el-link :underline="false" class="payMain_footList">个人</el-link>
          <el-link :underline="false" class="payMain_footList"
            >商品明细</el-link
          >
          <el-link :underline="false" class="payMain_footList">修改</el-link>
        </div> -->
      </div>
    </div>
    <!-- 底部订单信息 -->
    <div class="payFoot">
      <!-- <el-checkbox v-model="checked" style="margin-right: 0; margin-bottom: 8px"
        >同意签署<el-link
          type="primary"
          :underline="false"
          @click.prevent="$router.push('/transactionContract')"
          >电子交易合同</el-link
        ></el-checkbox
      >
      <el-checkbox v-model="checked2"
        >同意签署<el-link
          type="primary"
          :underline="false"
          @click.prevent="$router.push('/platformAuthorization')"
          >平台交易授权</el-link
        ></el-checkbox
      >
      <div class="line"></div> -->
      <div style="margin-bottom: 7px" class="payFoot_middle">
        <div>
          <!-- <img src="/static/image/quota.png" alt="" />
          <span
            >信用额度<span style="color: #f10203">{{ 0 }}</span
            >元</span
          > -->
        </div>
        <div>
          {{ totalNum }}&nbsp;件商品，总商品金额：<span
            style="font-size: 14px; color: #ff4019; margin-left: 20px"
            >￥</span
          ><span style="font-size: 21px; color: #ff4019">{{
            totalPrice.toFixed(2)
          }}</span>
        </div>
      </div>
      <div class="payFoot_middle">
        <div>
          <!-- <img src="/static/image/money.png" alt="" />
          <span
            >未付货款<span style="color: #f10203">{{ totalPrice }}</span
            >元</span
          > -->
        </div>
        <div>
          配送费用：<span style="color: #969696; margin-left: 14px"
            >￥0.00</span
          >
        </div>
      </div>
      <div class="line"></div>
      <div style="color: #333; margin-bottom: 10px">
        寄送至：<span style="color: #777" v-if="value">{{
          value.split(" ")[2] + value.split(" ")[3]
        }}</span>
      </div>
      <div style="color: #333">
        收货人：<span style="color: #777" v-if="value">{{
          value.split(" ")[0] + " " + value.split(" ")[1]
        }}</span>
      </div>
    </div>
    <!-- 操作按钮 -->
    <div class="payBtn">
      <el-button class="payBtn_back" @click="$router.push('/shopCar')">
        <i class="iconfont">&#xeb11;</i>返回购物车</el-button
      >
      <el-button class="payBtn_submit" type="primary" @click="submitOrder">
        提交订单</el-button
      >
    </div>
    <!-- 新增收货地址弹窗 -->
    <el-dialog
      title="新增收货地址"
      :visible.sync="dialogVisible"
      width="767px"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="收货人：" prop="name">
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入收货人"
            style="width: 270px"
            @input="ruleForm.name = ruleForm.name.replace(/\s+/g, '')"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在地区：" prop="area">
          <area-select
            v-if="isShowArea"
            v-model="ruleForm.area"
            :data="$pcaa"
            :level="3"
            style="display: flex; line-height: 18px"
            type="all"
          ></area-select>
        </el-form-item>

        <el-form-item label="详细地址：" prop="address">
          <el-input
            v-model="ruleForm.address"
            placeholder="请输入详细地址"
            style="width: 622px"
            @input="ruleForm.address = ruleForm.address.replace(/\s+/g, '')"
          ></el-input>
        </el-form-item>
        <el-row :gutter="15">
          <el-col :span="5"
            ><el-form-item label="手机号码：" prop="phone">
              <el-input
                v-model="ruleForm.phone"
                placeholder="请输入手机号码"
              ></el-input> </el-form-item
          ></el-col>
          <!-- <el-col :span="1" style="text-align:center;margin-top: 60px"
            >或
          </el-col>
          <el-col :span="5"
            ><el-form-item label="固定电话：" prop="telephone">
              <el-input
                v-model="ruleForm.telephone"
                placeholder="请输入固定电话"
              ></el-input> </el-form-item
          ></el-col> -->
        </el-row>
        <el-checkbox v-model="isDefaultAdr">设为默认地址</el-checkbox>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postAction, doGet, doPost } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
export default {
  data() {
    return {
      checked: true,
      checked2: true,

      options: [], //收货地址列表
      value: "", //选中的收货地址
      isShowArea: true, //用于销毁省市区组件
      dialogVisible: false, //新增收货地址弹窗是否显示
      goodsList: [], //商品列表
      goodsItems: [], //提交给后台的商品列表
      totalNum: 0, //商品总数
      totalPrice: 0, //商品总价
      buyRemark: "", //备注
      ruleForm: {
        //新增地址表单
        name: "",
        area: [],
        address: "",
        phone: ""
        // telephone: ""
      },
      rules: {
        //新增地址表单验证
        name: [{ required: true, message: "请输入收货人", trigger: "blur" }],
        city: [{ required: true, message: "请选择所在市", trigger: "change" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        area: [
          { required: true, message: "请选择所在地区", trigger: "change" }
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ]
        // telephone: [
        //   { required: true, message: "请输入固定电话", trigger: "blur" }
        // ]
      },
      isDefaultAdr: false, //新增地址是否设为默认地址
      deleteId: "",
      isExist: false,
      reduceNum: 0
    };
  },
  mounted() {
    //判断是直接购买,还是从购物车勾选购买
    //直接购买-商品列表从store存储中取
    if (this.$route.query.type && this.$route.query.type == 1) {
      this.getShopCar(0);
    } else {
      //购物车勾选购买-对购物车列表进行过滤，取到勾选中的商品
      this.value = this.$store.state.choosedAddress;
      this.getShopCar(1);
      this.isExist = true;
    }

    this.getAddressList();
  },
  methods: {
    /**
     * 获取购物车
     */
    getShopCar(type) {
      var that = this;
      doGet(
        httpConfig.shopCar.getShopCarUrl,
        { type: 0 },
        function(res) {
          if (res.flag) {
            var data = res.data;
            that.goodsList = [];
            if (type == 1) {
              var arr = that.$store.state.buyGoodsIds;

              arr.forEach(x => {
                data.forEach(item => {
                  if (item.id == x) {
                    item.info = JSON.parse(item.info);
                    that.goodsList.push(item);
                  }
                });
              });
            } else {
              that.goodsList = that.goodsList = [
                {
                  info: that.$store.state.buyList[0]
                }
              ];
              data.forEach(item => {
                item.info = JSON.parse(item.info);
                if (item.info.id == that.$store.state.buyList[0].id) {
                  that.deleteId = item.id;
                  that.isExist = true;
                  that.reduceNum = item.info.num;
                }
              });
            }
            if (that.goodsList.length > 0) {
              that.getNewPrice(); //更新购物车价格
            }
          }
        },
        function(res) {}
      );
    },
    /**
     * 更新购物车中商品信息
     */
    getNewPrice() {
      for (var i = 0; i < this.goodsList.length; i++) {
        this.getList(this.goodsList[i].info.id, i);
      }
    },
    /**
     * 获取商品详情
     */
    getList(id, index) {
      var that = this;
      doGet(
        httpConfig.GoodsInfo.getDataUrl,
        { goodsId: id },
        function(res) {
          if (res.flag) {
            var goodData = res.data;
            goodData.num = that.goodsList[index].info.num;
            that.goodsList[index].info = goodData;
            var price = 0;
            goodData.intervalPriceList.forEach((item, ind) => {
              if (
                that.goodsList[index].info.num <
                goodData.intervalPriceList[0].startNum
              ) {
                price = item.price;
                that.goodsList[index].info.num =
                  goodData.intervalPriceList[0].startNum;
              } else if (
                ind == goodData.intervalPriceList.length - 1 &&
                that.goodsList[index].info.num >= item.startNum
              ) {
                price = item.price;
                return;
              } else if (
                ind != goodData.intervalPriceList.length - 1 &&
                that.goodsList[index].info.num >= item.startNum &&
                that.goodsList[index].info.num <= item.endNum
              ) {
                price = item.price;
                return;
              }
            });
            that.goodsList[index].info.wholesalePrice = price;
            //计算商品总数，总价
            that.totalNum = 0;
            that.totalPrice = 0;
            that.goodsItems = [];
            that.goodsList.forEach(item => {
              that.totalNum += item.info.num;
              that.totalPrice += item.info.num * item.info.wholesalePrice;
              var list = {
                goodsId: item.info.id,
                price: item.info.wholesalePrice,
                total: item.info.num,
                realPrice: item.info.num * item.info.wholesalePrice
              };
              that.goodsItems.push(list);
            });

            // if (index + 1 == that.goodsList.length) {
            //   that.getSelected();
            // }
          } else {
            that.$message({
              type: "error",
              message: res.message
            });
          }
        },
        function(res) {}
      );
    },
    /**
     * 获取地址列表
     */
    getAddressList() {
      var that = this;
      doGet(
        httpConfig.myAddress.getAddressUrl,
        {  },
        function(res) {
          if (res.flag) {
            that.options = res.data;
            if (that.$route.query.type && that.$route.query.type == 1) {
              that.value =
                res.data.length != 0
                  ? JSON.parse(res.data[0].address).label
                  : "";
            }
          } else {
            that.$message({
              type: "error",
              message: res.message
            });
          }
        },
        function(res) {}
      );
    },
    /**
     * 关闭新增收货地址弹窗
     */
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          this.resetForm("ruleForm");
          done();
        })
        .catch(_ => {});
    },
    /**
     * 确认添加收货地址
     */
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          var area =
            Object.values(this.ruleForm.area[0])[0] +
            Object.values(this.ruleForm.area[1])[0] +
            Object.values(this.ruleForm.area[2])[0] +
            Object.values(this.ruleForm.area[3])[0];
          // var areaCode = [
          //   Object.keys(this.ruleForm.area[0])[0],
          //   Object.keys(this.ruleForm.area[1])[0],
          //   Object.keys(this.ruleForm.area[2])[0],
          //   Object.keys(this.ruleForm.area[3])[0]
          // ];
          var shopAddress = JSON.parse(JSON.stringify(this.ruleForm));
          delete shopAddress.area;
          delete shopAddress.address;
          delete shopAddress.name;
          delete shopAddress.phone;

          // shopAddress["area"] = area;
          shopAddress["all"] = this.ruleForm.area;
          // shopAddress["areaCode"] = areaCode;
          shopAddress["label"] =
            this.ruleForm.name +
            " " +
            this.ruleForm.phone +
            " " +
            area +
            " " +
            this.ruleForm.address;
          doPost(
            httpConfig.myAddress.saveAddressUrl,
            {
              address: JSON.stringify(shopAddress),
              isDefault: that.isDefaultAdr ? 1 : 0
            },
            function(res) {
              if (res.flag) {
                that.resetForm("ruleForm");
                that.getAddressList();
                that.$message({
                  message: "新增成功",
                  type: "success"
                });
              } else {
                that.$message({
                  type: "error",
                  message: res.message
                });
              }
            },
            function(res) {}
          );
        } else {
          return false;
        }
      });
    },
    /**
     * 取消添加收货地址
     */
    resetForm(formName) {
      this.isDefaultAdr = false;
      this.$refs[formName].resetFields();
      this.isShowArea = false;
      var t = setTimeout(() => {
        this.isShowArea = true;
      }, 0);
      this.dialogVisible = false;
    },
    /**
     * 点击新增收货地址
     */
    showDialog() {
      if (this.options.length > 19) {
        this.$message({
          message: "最多可以添加20条地址，如需新增，请先删除一条",
          type: "warning"
        });
        return;
      }
      this.dialogVisible = true;
    },
    /**
     * 提交订单
     */
    submitOrder() {
      if (
        this.$cookies.get("userInfo").pcAccount.indexOf("cztcs") != -1 ||
        this.$cookies.get("userInfo").pcAccount.indexOf("spbcs") != -1
      ) {
        this.$message.warning("当前账号为测试账号，无法下单！");
        return;
      }
      if (this.totalNum == 0) {
        this.$message.warning("订单内无商品，请先添加商品！");
        return;
      }
      if (!this.checked) {
        this.$message.warning("请先同意签署电子交易合同！");
        return;
      }
      if (!this.checked2) {
        this.$message.warning("请先同意签署平台交易授权！");
        return;
      }
      var that = this;
      if (this.value == "" || this.value == undefined || this.value == null) {
        this.$message.warning("请选择收货地址");
      } else {
        this.$confirm("请确认您的订购商品及数量，供应商将按照您的订单给您发货")
          .then(_ => {
            postAction(
              httpConfig.orderPay.submitUrl,
              {
                supplierId: -1,
                orderSource: 2,
                price: that.totalPrice,
                goodsPrice: that.totalPrice,
                merchantId: 1,
                pickerName: that.value.split(" ")[0],
                pickerMobile: that.value.split(" ")[1],
                buyRemark: that.buyRemark,
                useCouponId: 0,
                useCouponCode: "",
                discountPrice: 0,
                saleActivityId: -1,
                orderType: 1,
                goodsCount: that.totalNum,
                regionInfo: that.value.split(" ")[2],
                detailInfo: that.value.split(" ")[3],
                goodsItems: that.goodsItems
              },
              function(res) {
                if (res.flag) {
                  that.$store.commit("saveOrderId", res.data.id);
                  if (that.isExist) {
                    var arr = that.$store.state.buyGoodsIds;
                    doGet(
                      httpConfig.shopCar.batchDeleteShopCarUrl,
                      {
                        ids:
                          that.$route.query.type && that.$route.query.type == 1
                            ? that.deleteId
                            : arr.join(","),
                        type: 0
                      },
                      function(res) {
                        if (res.flag) {
                          that.$store.commit(
                            "saveShopCarNum",
                            that.$store.state.shopCarNum -
                              (that.$route.query.type &&
                              that.$route.query.type == 1
                                ? that.reduceNum
                                : that.totalNum)
                          );
                          that.$message({
                            type: "success",
                            message: "提交成功!"
                          });

                          that.$router.push("/proofPay");
                        }
                      },
                      function(res) {}
                    );
                  } else {
                    that.$message({
                      type: "success",
                      message: "提交成功!"
                    });

                    that.$router.push("/proofPay");
                  }
                } else {
                  that
                    .$confirm(res.message)
                    .then(_ => {
                      if (res.code == 1 || res.code == 3) {
                        that.$router.push("/register");
                      } else if (res.code == 2) {
                      }
                    })
                    .catch(_ => {});
                }
              },
              function(res) {}
            );
          })
          .catch(_ => {});
      }
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/orderPay";
</style>



// WEBPACK FOOTER //
// src/components/page/orderPay.vue